import { refinementList } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './algolia-create-instance';

document.addEventListener("DOMContentLoaded", function() {
  const tgblAlgoliaFrontend_json = window.atob(tgblAlgoliaFrontend_e);
  const tgblAlgoliaFrontend = jQuery.parseJSON(tgblAlgoliaFrontend_json);
  const LOCALIZED = tgblAlgoliaFrontend.localized;

  // Get all elements with refinement list class
  const elements = document.querySelectorAll("[data-filter-type='refinementList']")
  const elementsArray = Array.from(elements)
  
  // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);
      
      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        let AlgoliaRefinementList = ($, search, element) => {
          const facetMappings = JSON.parse(element.getAttribute('data-facet-mappings'))
          search.addWidgets([
            refinementList({
              container: element,
              attribute: element.getAttribute('data-attribute'), 
              cssClasses: {
                root: '',
                list: 'tgbl-refinement-list',
                item: 'tgbl-refinement-list__item tgbl-refinement-item',
                selectedItem: '',
                label: 'tgbl-refinement-item__label',
                labelText: 'tgbl-refinement-item__text',
                checkbox: 'tgbl-refinement-item__checkbox',
                count: 'tgbl-refinement-item__count',
              },
              transformItems(items) {
                return items.map(item => ({
                  ...item,
                  label: facetMappings[item.label] ?? item.label,
                  highlighted: facetMappings[item.label] ?? item.label
                })
              )}
            })
          ]);
          registerWidget(element);
        };
        AlgoliaRefinementList($, search, element);
      });
    }
  }
});

window.addEventListener('algoliaInstanceCreated', () => {
  const elements = document.querySelectorAll("[data-filter-type='refinementList']")
  const elementsArray = Array.from(elements)
  

  // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      
      elementsWithSameIndex.forEach(element => {
        const indexName = element.getAttribute('data-index')
        const attribute = element.getAttribute('data-attribute')
        const preselectedRefinementsAttribute = element.getAttribute('data-preselected-refinements')

        console.log('preselectedRefinementsAttribute: "' + preselectedRefinementsAttribute + '"');

        if(preselectedRefinementsAttribute !== "" && preselectedRefinementsAttribute != null && preselectedRefinementsAttribute != "\"\"" ) {
          const preselectedRefinements = JSON.parse(element.getAttribute('data-preselected-refinements'))
          let filterString = null;
          if(preselectedRefinements.length > 0) {
            preselectedRefinements.forEach(element => {
              if(filterString === null) {
                filterString = element;
              } else {
                filterString = filterString + '. ' + element
              }
            })
          }
          const search = getInstance(indexName)
          
          search.renderState[indexName].refinementList[attribute].refine(preselectedRefinements)
        }
      })
    }
  }
});